<template>
  <!-- 离职 -->
  <div
    class="detail"
    v-if="show"
  >
    <ax-panel :noTitle="true">
      <van-cell
        title="姓名"
        :value="data.header.emplid_description"
      ></van-cell>
      <van-cell
        title="员工类型"
        :value="data.header.empl_class_description"
      ></van-cell>
      <van-cell
        title="所属部门"
        :value="data.header.deptid_description"
      ></van-cell>
      <van-cell
        title="职位"
        :value="data.header.qh_external_posn"
      ></van-cell>
      <van-cell
        title="离职原因"
        :value="data.header.qh_ter_act_reason_description"
      ></van-cell>
      <van-cell
        title="最后工作日"
        :value="data.header.termination_dt"
      ></van-cell>
      <van-cell
        title="年假剩余天数预算"
        :value="data.header.qh_ann_balanc_day"
      ></van-cell>
    </ax-panel>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      show: false
    };
  },
  mounted() {
    console.log(this.$route.query);
  },
  watch: {
    data() {
      const current_oprid = this.data.current_oprid;
      const step_node = JSON.parse(this.data.step_node);
      const emplid = this.data.header.emplid;
      const action = this.data.action;
      this.show = this.ifShow(current_oprid, emplid, action, step_node);
      if (!this.show) {
        this.$dialog
          .alert({
            message: '已完成的审批暂时无法查询请知悉'
          })
          .then(() => {
            console.log('offer已审批');
          });
      }
    }
  },
  methods: {
    ifShow(curid, emplid, action, step_node) {
      let inNode = false;
      step_node.forEach((item) => {
        if (item.actual[0] === emplid) {
          inNode = true;
        }
      });
      return curid === emplid && action === 'V' && !inNode;
    }
  }
};
</script>
<style lang="scss" scoped>
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.6rem;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.base {
  border-bottom: none;
}
.van-cell__right-icon {
  // margin-left: -2.8rem;
  // float: right;
  position: absolute;
  right: 0.1rem;
}
.van-cell .van-cell__title {
  width: 4rem;
  // color:#000
}
.w100 .van-cell__title {
  width: 8rem;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
.title {
  color: rgba(0, 0, 0, 0.3);
  // color: #000;
  font-size: 0.4rem;
  text-align: left;
  padding-left: 0.42667rem;
}
.desc {
  color: #ccc;
  padding-left: 25px;
  font-size: 0.35rem;
  text-align: left;
}
</style>